import { render, staticRenderFns } from "./getresto-loading-modal.vue?vue&type=template&id=643fc4e2"
import script from "./getresto-loading-modal.vue?vue&type=script&lang=ts"
export * from "./getresto-loading-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643fc4e2')) {
      api.createRecord('643fc4e2', component.options)
    } else {
      api.reload('643fc4e2', component.options)
    }
    module.hot.accept("./getresto-loading-modal.vue?vue&type=template&id=643fc4e2", function () {
      api.rerender('643fc4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/getresto-loading-modal.vue"
export default component.exports